// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ClearOutlinedSvg from "@ant-design/icons-svg/es/asn/ClearOutlined";
import AntdIcon from '../components/AntdIcon';

var ClearOutlined = function ClearOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ClearOutlinedSvg
  }));
};

ClearOutlined.displayName = 'ClearOutlined';
export default /*#__PURE__*/React.forwardRef(ClearOutlined);